import { useState } from 'react';
import { Box, Collapse, Link, Typography } from '@mui/material';
import { AiConversationDetail, AiStoredMessage } from '../../../types';
import AiMessage from './AiMessage';

// Read-only transcript. Stored messages render through AiMessage so markdown
// and charts look identical to live chat. With showQueries (admin), each
// assistant message gets a "queries run" disclosure.

const QueriesDisclosure = ({ message }: { message: AiStoredMessage }) => {
  const [open, setOpen] = useState(false);
  if (!message.toolCalls || message.toolCalls.length === 0) return null;
  return (
    <Box ml={1} mb={1}>
      <Link component="button" variant="caption" onClick={() => setOpen(!open)}>
        {open ? 'Hide' : 'Show'} {message.toolCalls.length}{' '}
        {message.toolCalls.length === 1 ? 'query' : 'queries'} run
      </Link>
      <Collapse in={open}>
        {message.toolCalls.map((call, index) => (
          <Box key={index} my={0.5}>
            <code>{call.tool}</code>
            <pre style={{ background: '#f5f7fa', padding: 8, borderRadius: 4, fontSize: 12, overflowX: 'auto' }}>
              {JSON.stringify(call.input, null, 2)}
            </pre>
          </Box>
        ))}
      </Collapse>
    </Box>
  );
};

const AiConversationViewer = ({
  conversation,
  showQueries,
  hideHeader,
}: {
  conversation: AiConversationDetail;
  showQueries?: boolean;
  hideHeader?: boolean;
}) => (
  <Box>
    {hideHeader ? null : (
      <Typography variant="caption" color="text.secondary">
        {conversation.ownerName || 'Unknown account'}
        {conversation.userName ? ` — ${conversation.userName}` : ''}
      </Typography>
    )}
    {conversation.messages.map((message) => (
      <Box key={message.id}>
        <AiMessage
          message={{
            role: message.role,
            content: message.content,
            truncated: message.truncated,
          }}
        />
        {showQueries && message.role === 'assistant' ? <QueriesDisclosure message={message} /> : null}
      </Box>
    ))}
  </Box>
);

export default AiConversationViewer;
